// extracted by mini-css-extract-plugin
module.exports = {"refundInformation":"style_refundInformation__GVbhV","bold":"style_bold__1bINM","refund":"style_refund__DQsBL","hidden":"style_hidden__3K0DY"};